import React, { useContext } from "react";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";

function Header(props) {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  function openModal() {
    appDispatch({ type: "OPEN_REINIT_PARCOURS_MODAL" });
  }

  function openVueGlobale() {
    appDispatch({ type: "OPEN_VUE_GLOBALE" });
  }

  function handleStartAudioClick() {
    appDispatch({
      type: "OPEN_MEDIA_PLAYER",
      mediaType: "audio",
      mediaSrc: appState.livre.startAudio,
    });
  }

  return (
    <header className={`page-header ${props.pageName}-header`}>
      <div className={`page-header__titles ${props.pageName}-header__titles`}>
        <h1
          className={`page-header__titles--title ${props.pageName}-header__titles--title`}
          dangerouslySetInnerHTML={{ __html: props.titre }}
        ></h1>
        <span
          className={`page-header__titles--subtitle ${props.pageName}-header__titles--subtitle`}
          dangerouslySetInnerHTML={{ __html: props.sousTitre }}
        ></span>
      </div>
      <div className="page-header__buttons">
        {props.showReinit ? (
          <button onClick={openModal} className="btn-reinit-all">
            Réinitialiser le parcours
          </button>
        ) : null}

        <button onClick={openVueGlobale} className="btn-vue-globale">
          Vue globale
        </button>
        <button
          className="btn-fermer"
          onClick={() => {
            window.top.postMessage({ action: "close" }, window.location.origin);
          }}
        >
          Fermer
        </button>
      </div>
      {props.showMascotte ? (
        <>
          {/* <div className="page-header__start">
						<button className="btn btn-play">
							<span className="visually-hidden">Jouer l’audio d’introduction au chapitre</span>
						</button>
					</div> */}
          <div className={`page-header__mascotte`}>
            <img
              src={`images/${props.isbn}/mascotte-${props.chapitreId}.png`}
              alt=""
            />
          </div>
        </>
      ) : null}

      {props.showStart ? (
        <div className="page-header__start">
          <button
            className="btn btn-play btn-depart"
            onClick={handleStartAudioClick}
          >
            <span className="visually-hidden">
              Jouer l’audio d’introduction au parcours
            </span>
          </button>
          <h2>Départ</h2>
        </div>
      ) : null}
    </header>
  );
}

export default Header;
